/*@ngInject*/
const PropertiesFilter = function () {
    return function (items, props) {
        let out = [];

        if (_.isArray(items)) {
            let keys = Object.keys(props);

            _.each(items, function (item) {
                let itemMatches = false,
                    prop,
                    text;
                for (let i = 0; i < keys.length; i++) {
                    prop = keys[i];
                    text = props[prop].toLowerCase();
                    if (!_.isNil(item[prop]) && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    };
};

angular.module('gw-um-email-editor')
    .filter('propertiesFilter', PropertiesFilter);
